import React from 'react';

type EmptyStateProps = {
  title: string;
  description?: string;
  className?: string;
};

const EmptyState = ({
  title,
  description,
  className = 'empty-state',
}: EmptyStateProps) => {
  return (
    <div className={className}>
      <div className="empty-state__content">
        <h2 className="h3">{title}</h2>
        {description && (
          <p className="empty-state__description">{description}</p>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
